import UnpublishedChangesWarningHeader from './UnpublishedChangesWarningHeader';



export default UnpublishedChangesWarningHeader;
